import { IHttpClientRequestParameters } from './interfaces/IHttpClientRequestParameters';
import storage from '../common/localStorage';
import { postRefreshToken } from './services/authService';
import { syncTokens } from '../slices/userSlice';
import jwtDecode from 'jwt-decode';
import JWTToken from './models/jwt';
import { EnhancedStore } from '@reduxjs/toolkit';

const ValidateToken = (
  params: IHttpClientRequestParameters,
  store: EnhancedStore
): Promise<IHttpClientRequestParameters> => {
  const localTokens = storage.GetTokens();

  // If token isn't required, we don't need to validate
  if (!params.requiresToken) return Promise.resolve(params);

  // Get token
  const token = localTokens?.token;
  if (!token) throw Error('Token is missing.');

  // Decode jwt
  const jwt = jwtDecode(token) as JWTToken;
  if (!jwt) throw Error('Unable to decode token.');

  // Token hasn't expired yet
  if (jwt.exp >= new Date().getTime() / 1000) {
    params.headers = { ...params.headers, Authorization: `Bearer ${token}` };
    return Promise.resolve(params);
  }

  // Get refresh token
  const refreshToken = localTokens?.refreshToken;
  if (!refreshToken) throw Error('Refresh token is missing.');

  return postRefreshToken(refreshToken)
    .then((result) => {
      if (result.status === 200) {
        // Update store
        store.dispatch(
          syncTokens({
            token: result.data.token,
            refreshToken: result.data.refreshToken,
            sessionTime: result.data.sessionTime.toString(),
            countDownTime: result.data.countDownTime.toString()
          })
        );

        // Update params
        params.headers = {
          ...params.headers,
          Authorization: `Bearer ${result.data.token}`,
        };
        return Promise.resolve(params);
      }
    })
    .then(() => {
      return Promise.resolve(params);
    });
};

export default ValidateToken;
